import React, { useEffect, useMemo, useState, useRef } from "react";
import SearchableDropdown from "../common/SearchableDropdown";
import {
  getAllSubscriptions,
  updateTeacherSubscription,
  getPlans,
} from "../../requests";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { notifyError, notifySuccess } from "../helper/Toaster";
import { format_Date, formatDateForInput } from "../helper/formatters";

const Subscription = () => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editingData, setEditingData] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [planOptions, setPlans] = useState([]);

  const [drpName, setDrpName] = useState("");
  const [drpPlan, setDrpPlan] = useState("");

  const [refresh, setRefresh] = useState(false);

  const statusOptions = ["Active", "Cancelled"];

  const timeoutRef = useRef(null);

  const handleEdit = (row) => {
    setEditingId(row.id);
    setEditingData({
      id: row.id,
      plan: row.plan ?? "",
      status: row.is_cancelled ? "Cancelled" : row.status == 1 ? "Active" : "Inactive",
      start_date: row.start_date ?? "",
      end_date: row.end_date ?? "",
      used_credits: Number.isFinite(Number(row.used_credits))
        ? Number(row.used_credits)
        : 0,
    });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditingData(null);
  };

  const getAllPlans = async () => {
    try {
      const response = await getPlans();
      if (response.status == 200) {
        const arr = response.data.plans.map((p) => p.label);
        console.log(arr);
        
        setPlans(arr);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const handleSave = async () => {
    if (!editingData) return;

    if (editingData.status == "Cancelled") {
      if (!window.confirm("Are you sure you want to cancel this subscription? This action cannot be undone.")) {
        return;
      }
    }

  

    if(editingData.used_credits < 0) {
      notifyError("Used credits cannot be less than 0");
      return;
    }
   

    dispatch(startLoader());
    try {

      const response = await updateTeacherSubscription({
        subscription_id: editingId,
        plan: editingData.plan,
        status: editingData.status == "Inactive" ? 0 : 1,
        start_date: editingData.start_date,
        end_date: editingData.end_date,
        used_credits: editingData.used_credits,
        is_cancelled: editingData.status == "Cancelled" ? 1 : 0,
      });
      if (response.status == 200) {
        notifySuccess(response.data.message);
        getSubscriptionsData(page);
        // setRows((prev) =>
        //   prev.map((r) => {
        //     if (r.id !== editingId) return r;
        //     return {
        //       ...r,
        //       plan: editingData.plan,
        //       status: editingData.status == "Active" ? 1 : 0,
        //       start_date: editingData.start_date,
        //       end_date: editingData.end_date,
        //       used_credits: editingData.used_credits,
        //     };
        //   })
        // );
      }
    } catch (error) {
      console.error("Error updating teacher subscription:", error);
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
      setEditingId(null);
      setEditingData(null);
    }
  };

  const getSubscriptionsData = async (pageVal) => {
    dispatch(startLoader());
    try {
      const response = await getAllSubscriptions({
        page: pageVal,
        limit: limit,
        plan: drpPlan === "All plans" ? "" : drpPlan,
        name: drpName,
      });
      if (response.status == 200) {
        console.log(response.data);
        setRows(response.data.data);
        setTotalCount(response.data.totalCount);
      }
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    getAllPlans();
  }, []);

  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout to call the API after 1.5 seconds
    timeoutRef.current = setTimeout(() => {
      setPage(1);
      setRefresh(prev => !prev);
    }, 1500);

    // Cleanup function to clear timeout on unmount or when filterData changes again
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [drpPlan, drpName]);

  useEffect(() => {
    getSubscriptionsData(page);
  }, [page, limit, refresh]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <div className="overview-head">
        <div className="overview-head-left">Subscriptions</div>
        <div className="overview-head-right">
          <input
            type="text"
            className="my-input"
            style={{ backgroundColor: "#E5E7EB" }}
            placeholder="Enter name"
            value={drpName}
            onChange={(e) => setDrpName(e.target.value)}
          />
          <SearchableDropdown
            options={["All plans", ...planOptions]}
            selected={drpPlan}
            allowManualEntry={false}
            setSelected={(val) => setDrpPlan(val)}
            placeHolder="Select plan"
            color="#E5E7EB"
          />
        </div>
      </div>
      <div className="teacher-table" style={{ borderTop: "none" }}>
        <div className="teacher-table-head">
          {/* <div className="teacher-table-head-cell" style={{ width: "4%" }}>
          S. No
        </div> */}
          <div className="teacher-table-head-cell" style={{ width: "13%" }}>
            Name
          </div>
          <div className="teacher-table-head-cell" style={{ width: "15%" }}>
            Plan
          </div>
          <div className="teacher-table-head-cell" style={{ width: "8%" }}>
            Amount
          </div>
          <div className="teacher-table-head-cell" style={{ width: "10%" }}>
            Status
          </div>
          <div className="teacher-table-head-cell" style={{ width: "12%" }}>
            Start date
          </div>
          <div className="teacher-table-head-cell" style={{ width: "12%" }}>
            End date
          </div>
          <div className="teacher-table-head-cell" style={{ width: "10%" }}>
            Max credits
          </div>
          <div className="teacher-table-head-cell" style={{ width: "10%" }}>
            Used credits
          </div>
          <div
            className="teacher-table-head-cell"
            style={{ width: "10%", textAlign: "center" }}
          >
            Actions
          </div>
        </div>

        {rows.length === 0 && (
          <div
            style={{
              padding: "40px",
              textAlign: "center",
              color: "#9CA3AF",
            }}
          >
            No subscriptions found
          </div>
        )}

        {rows.length > 0 &&
          rows.map((row, i) => {
            const isEditing = editingId === row.id;
            return (
              <div
                key={row.id}
                className="teacher-table-row"
                style={{
                  borderBottom: i === rows.length - 1 && "none",
                }}
              >
                {/* <div className="teacher-table-row-cell" style={{ width: "4%" }}>
              {i + 1}
            </div> */}

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "13%" }}
                >
                  {row.name}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "15%" }}
                >
                  {isEditing ? (
                    <div className="tt-sdropdown">
                      <SearchableDropdown
                        options={planOptions}
                        selected={editingData?.plan || ""}
                        setSelected={(val) =>
                          setEditingData((p) => ({ ...p, plan: val }))
                        }
                        allowManualEntry={false}
                        showDrpDown={true}
                        placeHolder="Select..."
                        color="#FFFFFF"
                      />
                    </div>
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        padding: "2px 8px",
                        backgroundColor: "#E0F5FE",
                        color: "#01A7DE",
                        borderRadius: "4px",
                        fontSize: "12px",
                      }}
                    >
                      {row.plan}
                    </span>
                  )}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "8%"}}
                >
                  {'R' + row.amount}
                </div>
                <div
                  className="teacher-table-row-cell"
                  style={{ width: "10%" }}
                >
                  {isEditing ? (
                    <div className="tt-sdropdown">
                      <SearchableDropdown
                        options={statusOptions}
                        selected={editingData?.status || ""}
                        setSelected={(val) =>
                          setEditingData((p) => ({ ...p, status: val }))
                        }
                        allowManualEntry={false}
                        showDrpDown={true}
                        placeHolder="Select..."
                        color="#FFFFFF"
                      />
                    </div>
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 12px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "500",
                        backgroundColor:
                          row.is_cancelled ? "#FEE2E2" : row.status === 1
                            ? "#D1FAE5"
                            : row.status === 0
                            ? "#FEE2E2"
                            : "#F3F4F6",
                        color:
                          row.is_cancelled ? "#991B1B" : row.status === 1
                            ? "#065F46"
                            : row.status === 0
                            ? "#991B1B"
                            : "#6B7280",
                      }}
                    >
                      { row.is_cancelled ? "Cancelled" : row.status === 1
                        ? "Active"
                        : row.status === 0
                        ? "Inactive"
                        : "Unknown"}
                    </span>
                  )}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "12%" }}
                >
                  {isEditing ? (
                    <input
                      type="date"
                      value={formatDateForInput(editingData?.start_date) || ""}
                      onChange={(e) =>
                        setEditingData((p) => ({
                          ...p,
                          start_date: e.target.value,
                        }))
                      }
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        outline: "none",
                      }}
                    />
                  ) : (
                    format_Date(row.start_date)
                  )}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "12%" }}
                >
                  {isEditing ? (
                    <input
                      type="date"
                      value={formatDateForInput(editingData?.end_date) || ""}
                      onChange={(e) =>
                        setEditingData((p) => ({
                          ...p,
                          end_date: e.target.value,
                        }))
                      }
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        outline: "none",
                      }}
                    />
                  ) : (
                    format_Date(row.end_date)
                  )}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "10%" }}
                >
                  {row.max_credits == -1 ? "Unlimited" : row.max_credits}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "10%" }}
                >
                  {isEditing ? (
                    <input
                      type="number"
                      min={0}
                      value={editingData?.used_credits ?? 0}
                      onChange={(e) =>
                        setEditingData((p) => ({
                          ...p,
                          used_credits: e.target.value,
                        }))
                      }
                      style={{
                        width: "100%",
                        padding: "6px 8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        outline: "none",
                      }}
                    />
                  ) : (
                    <span style={{ fontSize: "14px", fontWeight: "bold" ,textAlign: "center"}}>
                      {row.used_credits}
                    </span>
                  )}
                </div>

                <div
                  className="teacher-table-row-cell"
                  style={{ width: "10%", textAlign: "center" }}
                >
                  {isEditing ? (
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        onClick={handleSave}
                        className="my-btn"
                        style={{
                          backgroundColor: "#01A7DE",
                          color: "#FFFFFF",
                          padding: "6px 10px",
                          fontSize: "12px",
                        }}
                      >
                        Save
                      </button>
                      <button
                        onClick={handleCancelEdit}
                        className="my-btn"
                        style={{
                          backgroundColor: "#E5E7EB",
                          color: "#030712",
                          padding: "6px 10px",
                          fontSize: "12px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => handleEdit(row)}
                      className="my-btn"
                      style={{
                        backgroundColor: "#E5E7EB",
                        color: "#030712",
                        padding: "6px 10px",
                        fontSize: "12px",
                      }}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      <div className="di-flex" style={{ width: "100%" }}>
        <div style={{ color: "#6B7280" }}>
          {" "}
          Showing {(page - 1) * limit + 1} to {rows.length + (page - 1) * limit}{" "}
          out of {totalCount} items{" "}
        </div>
        <div className="di-flex" style={{ justifyContent: "end", gap: "10px" }}>
          <button
            disabled={page == 1}
            className="my-btn"
            style={{
              backgroundColor: "#E0F5FE",
              color: "#01A7DE",
              opacity: page == 1 ? 0.4 : 1,
            }}
            onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
          >
            Previous
          </button>
          <button
            disabled={rows.length + (page - 1) * limit >= totalCount}
            className="my-btn"
            style={{
              backgroundColor: "#E0F5FE",
              color: "#01A7DE",
              opacity: rows.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
            }}
            onClick={() => setPage((p) => (rows.length ? p + 1 : p))}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
